var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"share_video"}),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"dot_wrap"},[_c('span',{staticClass:"dot"}),_vm._v("Click on dot to get tracker ")])}]

export { render, staticRenderFns }